<!-- The <button> paints nothing; the inner disc carries the round tint so iOS
     Safari has no native button box to show behind the circle. -->
<button type="button" class="voice-preview-button" [ngClass]="{'playing': isPlaying, 'loading': isLoading}"
  [attr.aria-label]="ariaLabel" [attr.aria-pressed]="isPlaying" (click)="toggle($event)">
  <span class="voice-preview-disc">
    <rosie-loader *ngIf="isLoading"
      [config]="{show: true, customLoaderWrapperClass: 'rosie-btn-loader rosie-dark-loader voice-preview-loader'}"></rosie-loader>
    <ng-icon *ngIf="!isLoading" [name]="isPlaying ? 'heroPauseMini' : 'heroPlayMini'"></ng-icon>
  </span>
</button>
